import { IRootState } from "@src/config/reducers";
import { createSelector } from "reselect";

const accountSelector = createSelector(
  (root: IRootState) => root.unAuthenticatedReducer,
  (state) => state.account
);

export const localisationSelector = createSelector(
  accountSelector,
  (account) => account?.localisation
);
